import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import styles from '../my-downloads.scss';
import { actionCreators } from './actions';
import { Timer } from 'app/components/timer/timer';
import { ElementLoader } from 'ui';
import { ReportsViewState } from 'app/area/my-downloads/reports-view/types-store';
import { ReportsViewItem } from './reports-view-item';
import { reportsTranslations } from './constants';
import { reportStatusPollingInterval } from 'app/area/my-downloads/reports-view/constants';

export type ReportsContainerProps = ReportsViewState & typeof actionCreators & DefaultContainerProps;

export class ReportsComponent extends React.Component<ReportsContainerProps, void> {
  public static statePath: string = STATE.myDownloads;

  private renderExportsList = () => {
    const {
      reportsView: {
        download,
        reportStatus
      }
    } = this.props;

    return [...reportStatus].map((item, index) =>
      <div key={index} className={styles.myDownloadsListItem}>
        <ReportsViewItem
          {...this.props}
          reportFileId={item.reportFileId}
          download={download}
          status={item.status}
          createdDate={item.createdDate}
          contentType={item.contentType}
          description={item.report}
          scheduled={item.scheduled}
          emailed={item.emailed}
          emailReceivers={item.emailReceivers}
          companyReport={item.companyReport}
          favourite={item.favourite}
        />
      </div>);
  };

  public render() {
    const {
      reportsView: {
        reportStatus
      },
      translation
    } = this.props;

    const displayReportList = reportStatus && reportStatus.length > 0
      ? this.renderExportsList()
      : (!this.props.reportsView.reportStatus
        ? <ElementLoader />
        : <div className="no-content">{translation.report_no_data}</div>);

    return (<div className={styles.myDownloadsWrapper}>
      <h3 className={styles.downloadHeading}>{translation.report_title}</h3>
      <Timer
        callback={this.props.loadReportStatus}
        interval={reportStatusPollingInterval}>
        {displayReportList}
      </Timer>
    </div>);
  }
}

const container = containerFactory(ReportsComponent, actionCreators, {}, reportsTranslations);

export { container as ReportsView };
